module.exports = __webpack_public_path__ + "img/item-5-1.c414f4f6.png";